import Vue from 'vue'
import Vuex from 'vuex'
// import actions from './actions'
// import mutations from './mutations'
// import getters from './getters'
import home from "./modules/home";
import list from "./modules/list";
import detail from "./modules/detail";

Vue.use(Vuex)

export function createStore () {
  return new Vuex.Store({
    state: {
      // itemsPerPage: 20,
      //detail: {},
      //categorys: []
    },
    // actions,
    // mutations,
    // getters,
    modules: {
      home,
      list,
      detail,
    },
  })
}



// WEBPACK FOOTER //
// src/store/index.js